import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';

import { FilterEnum, ItemStorageLocationEnum } from 'Common/FieldEnum';
import { ITEM_STORAGE_LOCATION_FORM_NAME } from 'Common/FormEnum';
import SetStorageLocationComponent from '../components/SetStorageLocation';
import { StorageLocationEnum } from '../../manageprocessorder/helper';

class SetStorageLocation extends Component {
  handleApplyToAll = () => {
    const { itemStorageLocationData, storageLocation, change } = this.props;
    const assignedStorage = {};
    itemStorageLocationData &&
      itemStorageLocationData.SiteStorageLocList &&
      itemStorageLocationData.SiteStorageLocList.length &&
      itemStorageLocationData.SiteStorageLocList.forEach(store => {
        assignedStorage[store[ItemStorageLocationEnum.SiteId]] =
          storageLocation === StorageLocationEnum.Unassigned
            ? StorageLocationEnum.Empty
            : storageLocation;
      });
    Object.keys(assignedStorage).length &&
      change(ItemStorageLocationEnum.ItemStorageLocationInfo, [
        assignedStorage,
      ]);
  };
  componentWillUnmount() {
    this.props.reset();
  }

  render() {
    const {
      itemStorageLocationData,
      storageLocationData,
      fetchingItemStorageLocation,
      handleSubmit,
      gridStorageLocationDataLoading,
      gridStorageDropDownData,
    } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <SetStorageLocationComponent
          itemStorageLocationData={itemStorageLocationData}
          storageLocationData={storageLocationData}
          fetchingItemStorageLocation={fetchingItemStorageLocation}
          handleApplyToAll={this.handleApplyToAll}
          gridStorageLocationDataLoading={gridStorageLocationDataLoading}
          gridStorageDropDownData={gridStorageDropDownData}
        />
      </Form>
    );
  }
}

SetStorageLocation = reduxForm({
  form: ITEM_STORAGE_LOCATION_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true,
})(SetStorageLocation);

const selector = formValueSelector(ITEM_STORAGE_LOCATION_FORM_NAME);
const mapStateToProps = state => {
  const {
    CommonState: { filters },
    ItemMaintenanceState: { itemStorageLocation },
  } = state;

  const {
    itemStorageLocationData,
    fetchingItemStorageLocation,
    gridStorageLocationDataLoading,
    gridStorageDropDownData,
  } = itemStorageLocation;
  return {
    storageLocationData: filters.storageLocationData,
    itemStorageLocationData,
    fetchingItemStorageLocation,
    gridStorageLocationDataLoading,
    gridStorageDropDownData,
    itemStorageLocationInfo: selector(state, [
      ItemStorageLocationEnum.ItemStorageLocationInfo,
    ]),
    storageLocation: selector(state, [FilterEnum.GroupId_Location]),
  };
};

export const SetStorageLocationContainer = connect(
  mapStateToProps,
  null
)(SetStorageLocation);



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/containers/SetStorageLocation.js